<template>
    <div class="container-fluid" v-if="ready">
        <div class="row">
            <aside class="filters px-0 mb-4 mb-lg-0 filters-column-container" :class=" store.getters.areFiltersOpen ? '' : 'closed' ">
                <results-filter
                    ref="resultsFilters"
                    key="results-filter"
                    :numResults=" sortedResults?.length ?? 0 "
                    @changeFilters="onChangeFilters"
                ></results-filter>
            </aside>

            <div class="search-results">
                <div class="container">
                    <section class="results-section">

                        <result-header
                            key="result-header"
                            :resultsCount="iCountResults"
                            :page="page"
                            :totalPage="totalPage"
                            @change-layout-mode="onChangeLayoutMode"
                            @change-sort-mode="onChangeSortMode"
                            @unchecked="onUnchecked"

                            @on-clear-results="onUnchecked"
                        />

                        <div class="results row" :class="cssLayout">

                                <resource-card
                                    v-for="(resource,index) in pageResults"
                                    :key="'resource' + Math.random() * 2000"
                                    :resource="resource"
                                />

                        </div>

                    </section>

                    <result-pagination
                        key="result-pagination"
                        :page="page + 1"
                        :totalPage="totalPage"
                        @change-page="changePage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import { computed, ref, onMounted, watch } from "vue";
    import { useStore } from "vuex";
    import { useHash } from "./composables/Hash";

    //COMPONENTS
    import ResultsFilter    from "./components/ResultsFilter";
    import ResourceCard     from "./components/ResourceCard";
    import ResultHeader     from "./components/ResultHeader";
    import ResultPagination from "./components/ResultPagination";

    //PLUGINS
    let store = useStore();
    let hash = useHash();

    //DATA/REF
    let page = ref(0);
    let ready = ref(false);
    let resultsFilters = ref(null);
    let layoutMode = ref(""); //this will be set on mounted
    let sortMode = ref(""); //this will be set on mounted
    let itemInPage = 30;

    //COMPUTED
    let copydeck = computed(() => store.state.copydeck);
    let results = computed( () => store.state.results );
    let checked = computed( () => store.state.checked ?? [] );
    let shouldFilter = computed( () => store.getters.shouldFilter ?? false );

    //let filteredResults = computed( () =>  shouldFilter.value ? filterResults(shouldFilter.value) : results.value );
    let filteredResults = computed( () =>  store.getters.filteredResults );
    let sortedResults = computed( () => sortResults( sortMode.value ) );
    let startResult = computed ( () => page.value * itemInPage);
    let pageResults = computed( () => sortedResults.value.slice(startResult.value, startResult.value + itemInPage))
    let iCountResults = computed( () => filteredResults.value.length );
    let totalPage = computed( () => Math.ceil(iCountResults.value / itemInPage) );

    let cssLayout = computed( () => `list-display-mode_${layoutMode.value}`);

    defineExpose({ changePage, clearFilters })
    let emits = defineEmits(["update-url"]);

    //METHODS
    function onChangeLayoutMode (layout)
    {
        layoutMode.value = layout;
        localStorage.setItem("amelio.layoutMode", layout)
    }

    function onChangeSortMode (sort)
    {
        sortMode.value = sort;
        localStorage.setItem("amelio.sortMode", sort)
    }

    function onChangeFilters ()
    {
/*console.log(("onChangeFilters"))*/;        updateHash();
    }


    function changePage (newPage)
    {
/*console.log(("changePage", newPage))*/;        if (newPage > 0 && newPage <= totalPage.value)
        {
            page.value = newPage - 1;
            updateHash();
        }
    }

    function clearFilters (justChange = false)
    {
        resultsFilters.value.clearFilters(justChange);
    }

    function updateHash ()
    {

        window.location.hash = "page=" + (page.value + 1);
        emits("update-url")
    }

    function onUnchecked (id)
    {
        emits("update-url")
    }



    function filterResults ()
    {
        //checked.value.length === 0 ? store.state.results :

          if (shouldFilter)
         {
             // let allFilters = store.getters.flatFilters;
             //
             // let filtersDescriptors =   store.getters.flatFilters('descriptor');
             // let filtersTypes =         store.getters.flatFilters('type');
             //
             // //Get only the ids of the checked filters group by type
             // let checkedDescriptors =   checked.value.filter( ch => ch.type === "descriptor").map( ch => ch.id);
             // let checkedTypes =         checked.value.filter( ch => ch.type === "type").map( ch => ch.id);
             //
             // //Get only the resources associated with the checked filters group by type
             // let resourceThatCanBeDisplayedFromDescriptors = filtersDescriptors.filter ( filter => checkedDescriptors.includes(filter.id)).map ( filter => filter.resources).flat();
             // let resourceThatCanBeDisplayedFromType = filtersTypes.filter ( filter => checkedTypes.includes(filter.id)).map ( filter => filter.resources).flat();
             //
             // //Merge resource
             // let resourceThatCanBeDisplayed = [...resourceThatCanBeDisplayedFromDescriptors, ...resourceThatCanBeDisplayedFromType];
             // let filteredResults = results.value.filter( resource => resourceThatCanBeDisplayed.includes(resource.id));
             //
             // store.commit("filteredResults", filteredResults);
             //
             // return filteredResults;
         }

        return results.value;
    }



    function sortResults (strSortMode)
    {

        let res;
        if (strSortMode === "alpha")
        {
            res = filteredResults.value.sort ( (a,b) => a.title.localeCompare(b.title));
        }
        else
        {
            res = filteredResults.value.sort((a, b) => b.pertinence - a.pertinence);
        }

        return res;
    }


    //WATCH
    watch ( () => shouldFilter.value, (newVal, oldVal) =>
    {
        filterResults();
        changePage(1);
    })

    //LIFECYCLE
    function mounted ()
    {
        layoutMode.value = localStorage.getItem("amelio.layoutMode") ?? "grid";
        sortMode.value = localStorage.getItem("amelio.sortMode") ?? "pertinence";


        let iPage = hash.page;

        if (iPage === "")
            iPage = "1";

        page.value = parseInt(iPage) - 1;

        ready.value = true;
    }

    onMounted(mounted);

</script>

<style scoped>

</style>
